import React from 'react';
import '../style/Features.css';

// SVG иконки для более профессионального вида
const icons = {
  convenience: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),
  speed: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  support: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </svg>
  ),
  security: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  )
};

const features = [
  {
    title: 'Удобство 24/7',
    text: 'Консультации перед сделкой и поддержка в любое время суток.',
    icon: icons.convenience,
    colorClass: 'blue'
  },
  {
    title: 'Молниеносно',
    text: 'Среднее время поступления средств на кошелёк — до 10 минут.',
    icon: icons.speed,
    colorClass: 'orange'
  },
  {
    title: 'Забота о клиентах',
    text: 'Персональный менеджер и полное сопровождение каждой сделки.',
    icon: icons.support,
    colorClass: 'teal'
  },
  {
    title: 'Полная анонимность',
    text: 'Ваши данные под защитой. Обработка без лишней информации.',
    icon: icons.security,
    colorClass: 'indigo'
  }
];

export default function Features() {
  return (
    <section className="features-section">
      <div className="features-container">
        <div className="features-header">
          <h2 className="section-title">Почему выбирают <span className="brand-highlight">BilPay</span></h2>
          <p className="section-subtitle">Мы объединили безопасность банковского уровня с удобством современных технологий.</p>
        </div>
        
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className={`feature-card ${f.colorClass}`}>
              <div className="icon-wrapper">
                {f.icon}
              </div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-text">{f.text}</p>
              
              {/* Декоративный фон при ховере */}
              <div className="card-bg-decoration"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
